import link from "@/scripts/host.js";


export default {
  name: "Register",
  props: ["close"],
  data() {
    return {
      login: "",
      email: "",
      password: "",
      repeatPassword: "",
      invalidPassword: false,
      invalidEmail: false,
      invalidBigLetter: false,
      showErrorInfo: null
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch("toggleLoginModal");
    },
    checkEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    checkValid() {
      return (this.password !== this.repeatPassword && !this.checkEmail(this.email) && this.password === this.password.toLowerCase())
    },
    checkPassword() {
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
      return re.test(this.password);
    },
    register() {
      if(this.password === this.repeatPassword ){
        if(this.checkPassword()){
          if(this.checkEmail(this.email)){
            this.showErrorInfo = null;
            this.axios({
              method: 'post',
              url: `${link.hostLink}Account/Register`,
              data: {
                userName: this.login,
                email: this.email,
                password: this.password
                }
              }).then(() => {
                  this.$store.dispatch("toggleLoginModal");
              })
              .catch((error) => {
                this.showErrorInfo =error.response.data.exception;
              });
          } else {
            this.showErrorInfo = "Nieprawidłowy adres e-mail"
          }
        } else {
          this.showErrorInfo = "Hasło musi mieć minimum 6 znaków, w tym min. 1 wielką literę i 1 cyfrę";
        }
      } else {
        this.showErrorInfo = "Hasło nie jest takie samo w obu przypadkach";
      }
      // this.password !== this.repeatPassword? this.invalidPassword = true : this.invalidPassword = false;
      // !this.checkEmail(this.email)? this.invalidEmail = true : this.invalidEmail = false;
      // this.password === this.password.toLowerCase()? this.invalidBigLetter = true : this.invalidBigLetter = false;
      //
      // if (!this.checkValid()) {
      //   this.axios({
      //     method: "post",
      //     url: `${link.hostLink}Account/Register`,
      //     data: {
      //       userName: this.login,
      //       email: this.email,
      //       password: this.password
      //     }
      //   })
      //     .then(()=> {
      //       this.$store.dispatch("toggleLoginModal");
      //     })
      //}
    }
  },
  mounted() {}
};
